import { render, staticRenderFns } from "./ClickRow.vue?vue&type=template&id=36767da4&scoped=true&"
import script from "./ClickRow.vue?vue&type=script&lang=ts&"
export * from "./ClickRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36767da4",
  null
  
)

export default component.exports